<template>
  <section>
    <div class="botones-pagina">
      <button type="button"
              class="boton boton--nuevo"
              @click="crear"/>
    </div>
    <filtro-formulario @filtrar="fetchData" ref="filtroForm"/>
    <div v-if="formularios.length > 0">
      <table class="tabla tabla--responsive">
        <thead class="tabla__header">
          <tr>
            <th>Fecha de visita</th>
            <th>Fecha de reporte</th>
            <th>Informante</th>
            <th>Distrito</th>
            <th>Caserío</th>
            <th>Tipo</th>
            <th>Estado</th>
            <th/>
          </tr>
        </thead>
        <tbody class="tabla__body tabla__body--clickable tabla__body--striped">
          <tr v-for="(formulario, i) in formularios" :key="formulario._id">
            <td @click="ver(formulario, !formulario._id, i)" data-titulo="Fecha de visita: ">
              {{ formulario.fechaVisitaCampo | fecha }}
            </td>
            <td @click="ver(formulario, !formulario._id, i)" data-titulo="Fecha de reporte: ">
              {{ formulario.fechaReporte | fecha }}
            </td>
            <td @click="ver(formulario, !formulario._id, i)" data-titulo="Informante: ">
              {{ formulario.nombreInformante }}
            </td>
            <td @click="ver(formulario, !formulario._id, i)" data-titulo="Distrito: ">
              {{ formulario.ubicacion.distrito }}
            </td>
            <td @click="ver(formulario, !formulario._id, i)" data-titulo="Caserio: ">
              {{ formulario.ubicacion.caserio }}
            </td>
            <td @click="ver(formulario, !formulario._id, i)" data-titulo="Tipo: ">
              {{ mapaTipos[formulario.tipoForm] }}
            </td>
            <td @click="ver(formulario, !formulario._id, i)" class="estado__formulario">
              <span v-if="formulario.estado === 'borrador'" class="estado estado--amarillo">
                {{ formulario.estado }}
              </span>
              <span v-if="formulario.estado === 'nuevo'" class="estado estado--azul">
                {{ formulario.estado }}
              </span>
              <span v-if="formulario.estado === 'aprobado'" class="estado estado--verde">
                {{ formulario.estado }}
              </span>
              <span v-if="formulario.estado === 'rechazado'" class="estado estado--rojo">
                {{ formulario.estado }}
              </span>
              <span v-if="formulario.estado === 'borrado'" class="estado estado--negro">
                {{ formulario.estado }}
              </span>
            </td>
            <td>
              <ul class="tabla__opciones">
                <li
                v-if="formulario.estado === 'rechazado'
                || formulario.estado === 'borrador'"
                @click="ver(formulario, true, i)"
                class="tabla__opciones__elem"
                tooltip="Editar">
                  <i class="text--cyan fa fa-fw fa-edit"/>
                </li>
                <li
                v-if="formulario.estado === 'borrador'"
                class="tabla__opciones__elem"
                tooltip="Eliminar"
                @click="eliminar(formulario, i)">
                  <i class="text--tomate fa fa-fw fa-trash"/>
                </li>
                <li
                v-if="formulario.notas"
                class="tabla__opciones__elem"
                tooltip="Notas"
                @click="abrirNotas(formulario.notas)">
                  <i class="text--naranja fa fa-fw fa-comment-dots"/>
                </li>
                <li
                v-if="formulario.estado === 'aprobado'"
                class="tabla__opciones__elem"
                tooltip="Seguimiento"
                @click="abrirSeguimientos(formulario)">
                  <i class="text--marron fa fa-fw fa-clipboard-list"/>
                </li>
              </ul>
            </td>
          </tr>
        </tbody>
      </table>
      <p class="text--center" v-show="cargando">
        <i class="fa fa-spinner fa-spin fa-2x"/>
      </p>
    </div>
    <div v-else>
      <p class="no-results">
        <i class="fa fa-fw fa-list"/>
        <span>No hay formularios registrados.</span>
      </p>
    </div>
  </section>
</template>
<script>
import D from "debug";
import swal from "sweetalert2";
import union from "lodash/union";
import FiltroFormulario from "./FiltroFormulario.vue";

const debug = D("ciris:FormularioList.vue");

export default {
  name: "FormularioList",
  components: {
    FiltroFormulario,
  },
  data,
  computed: {
    formularios() {
      return union(
        this.$store.state.formulario.borradores,
        this.$store.state.formulario.formularios.docs,
      );
    },
  },
  methods: {
    ver,
    eliminar,
    fetchData,
    crear,
    abrirNotas,
    handleScroll,
    abrirSeguimientos,
  },
  created() {
    window.addEventListener("scroll", this.handleScroll, false);
    return this.fetchData(this.pagina, {
      estado: ["nuevo", "aprobado", "rechazado"],
      inspector: this.$store.state.usuario.usuario._id,
    });
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll, false);
  },
};

function data() {
  return {
    pagina: 1,
    cantidad: this.$store.state.app.cantPorPagina,
    mapaTipos: {
      ganado: "Ganado",
      aves: "Aves",
      perros: "Perros/gatos",
    },
    mostrarBorradores: false,
    cargando: false,
  };
}

function fetchData(pagina, filtro) {
  const params = { pagina: pagina - 1, cantidad: this.cantidad, filtro };
  this.pagina = pagina;
  return this.$store.dispatch(this.$actions.getBaseFormulario, params);
}

function ver(formulario, edit, pindex) {
  const index = formulario._id ? null : pindex;
  this.$store.commit(this.$actions.setFormulario, formulario);
  return this.$router.push({ name: formulario.tipoForm, params: { edit, index } });
}

function eliminar(formulario, index) {
  swal.fire({
    title: "Confirmación",
    text: "¿Está seguro que desea eliminar este formulario?",
    type: "warning",
    showCancelButton: true,
  }).then((resp) => {
    if (resp && !resp.dismiss) {
      if (!formulario._id) {
        return this.$store.commit(this.$actions.eliminarBorrador, index);
      }
      return this.$store.dispatch(this.$actions.eliminarFormulario, {
        formulario,
        delLocal: true,
        deLista: true,
      })
        .then(() => this.$toastr("success", "El formulario ha sido eliminado", "Éxito"))
        .catch(err => this.$toastr("error", err, "Error"));
    }
    return false;
  }).catch(err => this.$toastr("error", err, "Error"));
}

function crear() {
  return swal.fire({
    text: "Seleccione el tipo de formulario",
    input: "select",
    inputPlaceholder: "--",
    inputOptions: {
      ganado: "Ganado",
      aves: "Aves",
      perros: "Perros/Gatos",
    },
    showCancelButton: true,
    inputValidator: val => new Promise(resolve => (val ? resolve() : resolve("Debe seleccionar un tipo"))),
  }).then((resp) => {
    debug(resp.value);
    if (resp.value) {
      const index = this.$store.state.formulario.borradores.length;
      return this.$router.push({ name: resp.value, params: { edit: true, index } });
    }
    return false;
  });
}

function abrirNotas(text) {
  return swal.fire({
    title: "Comentarios",
    text,
  });
}

function abrirSeguimientos({ _id, consecutivo }) {
  const params = { idPadre: _id, consecutivo };
  this.$router.push({ name: "seguimientos", params });
}

function handleScroll() {
  const finalPagina = window.scrollY === (document.body.scrollHeight - window.innerHeight);
  const cargarMas = this.$store.state.formulario.formularios.docs.length
  < this.$store.state.formulario.formularios.cant;

  if (!this.cargando && finalPagina && cargarMas) {
    this.cargando = true;
    this.pagina += 1;
    return this.fetchData(this.pagina, this.$refs.filtroForm.filtro).then(() => {
      this.cargando = false;
      return true;
    });
  }
  return false;
}
</script>
<style media="screen" lang="scss">
  @import "~Sass/variables";


  @media only screen and (max-width: $reflex-md){
    .estado__formulario{
      position: absolute;
      right: -50px;
      top: 16px;
      transform: rotate(45deg);
    }
  }

  .estado{
    @extend %sans;
    display: inline-block;
    font-weight: 300;
    line-height: 1;
    width: 150px;
    padding: 3px;
    position: relative;
    text-align: center;
    vertical-align: middle;
    white-space: nowrap;
  }

  .estado--verde {
    background: $verde;
    background-color: $verde;
    color: $blanco;
  }
  .estado--amarillo {
    background: $amarillo;
    background-color: $amarillo;
    color: $negro4;
  }
  .estado--azul {
    background: $azul;
    background-color: $azul;
    color: $blanco;
  }
  .estado--rojo {
    background: $rojo;
    background-color: $rojo;
    color: $blanco;
  }
  .estado--negro {
    background: $negro;
    background-color: $negro;
    color: $blanco;
  }
</style>
